"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var JurisdictionButton_1 = require("./JurisdictionButton");
var JurisdictionPicker = function (props) {
    return (React.createElement("div", { className: "jurisdiction-picker" },
        React.createElement(JurisdictionButton_1.default, { setFieldValue: props.setFieldValue, text: 'England and Wales', imagePath: '/assets/img/countries/gb.svg', jurisdiction: 'england_wales', value: props.values.jurisdiction }),
        React.createElement(JurisdictionButton_1.default, { setFieldValue: props.setFieldValue, text: 'Scotland', imagePath: '/assets/img/countries/gb-sct.svg', jurisdiction: 'scotland', value: props.values.jurisdiction })));
};
exports.default = JurisdictionPicker;
